<template>
  <div class="step-one">
    <div class="person">
      <el-form ref="personForm" :model="personForm" :rules="personFormRules" size="small" label-width="140px">
        <el-form-item label="创作者" prop="authorName">
          <el-input v-model="personForm.authorName" maxlength="30" placeholder="请输入创作者"></el-input>
        </el-form-item>
        <!-- <el-form-item label="英文名" prop="realNameEn">
          <el-input v-model="personForm.realNameEn" maxlength="30" placeholder="请输入创作者英文名"></el-input>
        </el-form-item> -->
        <el-form-item v-if="type == 2" label="所属公司名称" prop="authorInfo">
          <el-input v-model="personForm.authorInfo" maxlength="30" placeholder="请输入所属公司名称"></el-input>
        </el-form-item>
        <el-form-item label="移动电话" prop="telephone">
          <el-input v-model="personForm.telephone" maxlength="11" placeholder="请输入移动电话" @change="teleChange"></el-input>
          <span style="color:red;font-size:12px;">（作为登录账号使用）</span>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode">
          <el-input v-model="personForm.smsCode" @blur="codeBlur" maxlength="11" placeholder="请输入验证码"></el-input>
          <el-button size="mini" type="primary" @click="send" style="width:92px;" :disabled="!!timer">{{ btnText }}</el-button>
        </el-form-item>
        <el-form-item label="国家">
          <el-select v-model="personForm.countryType">
            <el-option label="国内" :value="2"></el-option>
            <el-option label="国外" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国籍" placeholder="请选择国籍" prop="nationality">
          <el-select v-model="personForm.nationality">
            <div v-for="item in countryAllList" :key="item.code">
              <el-option :label="item.name" :value="item.code"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="画派" placeholder="请选择画派" prop="paintIds">
          <el-select multiple collapse-tags v-model="personForm.paintIds">
            <div v-for="item in paintList" :key="item.code">
              <el-option :label="item.name" :value="item.code"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐" placeholder="请选择推荐" prop="recommendTagIds">
          <el-select multiple collapse-tags v-model="personForm.recommendTagIds">
            <div v-for="item in recommendList" :key="item.code">
              <el-option :label="item.name" :value="item.code"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="创作者介绍" prop="remark">
          <el-input
            type="textarea"
            :rows="5"
            style="width: 250px!important;"
            maxlength="100"
            placeholder="例:职业画家、当代青年艺术家 ，毕业于中国美术学院"
            show-word-limit
            v-model="personForm.remark">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="">
          （含授权范围、二改禁忌、推广要求）
        </el-form-item> -->
        <el-form-item label="创作者照片" prop="authorPic">
          <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="personForm.authorPic" />
        </el-form-item>
        <el-form-item label="创作者文档介绍" prop="vedioSource">
          <MyUpload listType="text" info="仅支持PDF, 小于20M" accept="application/pdf" :imgKey.sync="personForm.vedioSource" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="personForm.password" placeholder="请输入密码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input type="password" v-model="personForm.confirmPwd" placeholder="请确认密码" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import md5 from 'md5'
import API from '../../lib/API'
import MyUpload from '../common/MyUpload.vue'
export default {
  name: 'step-one',
  components: {
    MyUpload,
  },
  props: {
    type: {
      type: String
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value.length < 6 || value.length > 20) {
        callback(new Error('请输入6~20位密码'))
      } else {
        if (this.personForm.confirmPwd !== '') {
          this.$refs.personForm.validateField('confirmPwd')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value.length < 6 || value.length > 20) {
        callback(new Error('请输入6~20位密码'))
      } else if (value !== this.personForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validatePassPaint = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请选择画派'))
      } else {
        callback()
      }
    }
    var validatePassRecommend = (rule, value, callback) => {
      console.log(value.length);
      if (value.length === 0) {
        callback(new Error('请选择推荐'))
      } else {
        callback()
      }
    }
    return {
      btnText: '发送验证码',
      time: 0,
      ossUrl: '',
      timer: null,
      ossData: {},
      codeSuccess: false,
      countryAllList: [],
      paintList: [],
      recommendList: [],
      personForm: {
        authorName: '',
        telephone: '',
        countryType: 2,
        password: '',
        confirmPwd: '',
        smsCode: '',
        authorInfo: '',
        nationality: '',
        paintIds: [],
        recommendTagIds: [],
        remark: '',
        vedioSource: '',
        authorPic: '',
      },
      personFormRules: {
        authorName: [{ required: true, message: '请输入创作者姓名', trigger: 'blur' }],
        // realNameEn: [{ required: true, message: '请输入创作者英文名', trigger: 'blur' }],
        paintIds: [{ validator: validatePassPaint}],
        recommendTagIds: [{ validator: validatePassRecommend }],
        nationality: [{ required: true, message: '请选择国籍', trigger: 'blur' }],
        authorInfo: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        vedioSource: [{ required: true, message: '请上传创作者文档介绍', trigger: 'blur' }],
        authorPic: [{ required: true, message: '请上传作者照片', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { min: 6, max: 6, message: '请输入6位验证码', trigger: 'blur' }],
        telephone: [{ required: true, message: '请输入正确的手机号码', trigger: 'blur' }, { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入创作者介绍', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: validatePass, trigger: 'blur' }],
        confirmPwd: [{ required: true, message: '请输入确认密码', trigger: 'blur' }, { validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getCountryList()
    this.getPaintList()
    this.getRecommendList()
  },
  methods: {
    getCountryList() {
      new API(this).POST({
        url: '/select/findCountryList',
        cb: res => {
          this.countryAllList = res
        }
      })
    },
    getPaintList() {
      new API(this).POST({
        url: '/select/findPaintList',
        cb: res => {
          this.paintList = res
        }
      })
    },
    getRecommendList() {
      new API(this).POST({
        url: "/select/findRecommendTagList",
        cb: res => {
          this.recommendList= res;
        }
      });
    },
    codeBlur() {
      this.codeValidated = true
      let { telephone, smsCode } = this.personForm
      this.$refs.personForm.validateField('smsCode', err => {
        if (err) return
        new API(this).POST({
          url: '/author/checkSmsCode',
          params: {
            telephone,
            smsCode
          },
          cb: () => {
            this.codeSuccess = true
          }
        })
      })
    },
    teleChange() {
      this.codeSuccess = false
    },
    getValidate() {
      return this.$refs.personForm.validate()
    },
    getFormData() {
      return { formDataOne: this.personForm }
    },
    sendApi() {
      let telephone = this.personForm.telephone
      let secretKey = md5(`${telephone}#anneleven`)
      new API(this).POST({
        url: '/author/getSmsCode',
        params: {
          telephone,
          secretKey
        }
      })
    },
    send() {
      this.$refs.personForm.validateField('telephone', err => {
        if (err) return
        this.sendApi()
        this.time = 60
        this.btnText = `${this.time}s`
        this.timer = setInterval(() => {
          if (this.time === 1) {
            clearInterval(this.timer)
            this.timer = null
            this.btnText = '重新发送'
          } else {
            this.time -= 1
            this.btnText = `${this.time}s`
          }
        }, 1000)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.step-one {
}
</style>



// WEBPACK FOOTER //
// src/components/producerRegister/StepOne.vue